import React from "react";
import ScoreBoard from "./ScoreBoard";   // ← Make sure path is correct

export default function ScorecardModal({ 
  onClose, 
  dailyTotalScore = 0, 
  streakInfo, 
  history = [] 
}) {
  return (
    <div className="fixed inset-0 bg-black/70 z-[60] flex items-center justify-center p-4">
      <div className="bg-white rounded-3xl w-full max-w-lg max-h-[90vh] overflow-hidden flex flex-col">
        <div className="p-5 border-b flex justify-between bg-[#F8F5FF]">
          <h2 className="text-xl font-bold text-[#2B2140]">📋 Scorecard</h2>
          <button onClick={onClose} className="text-sm lg:text-lg w-fit p-1 leading-none text-gray-400 hover:text-black">✕</button>
        </div>

        <div className="flex-1 p-5 overflow-auto space-y-6">
          <ScoreBoard dailyTotalScore={dailyTotalScore} streakInfo={streakInfo} />

          {history.length > 0 && (
            <div>
              <h3 className="font-bold text-[#2B2140] mb-3">Recent Days</h3>
              {history.slice(0, 5).map((day, i) => (
                <div key={i} className="flex justify-between items-center py-3 border-b last:border-0">
                  <div className="text-sm text-blue-600">
                    {day.playDate} <span className="text-[#4d3d71]">• {day.theme}</span>
                  </div>
                  <div className="font-bold text-[#7C3AED]">{day.totalScore} pts</div>
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}